import { defineStore } from 'pinia'
import { StoreHelper } from '../../helpers/storeHelper'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as any
  }),
  actions: {
    async getUserProfile({ headers, url }: { headers?: any, url?: string }) {
      const { findAll } = StoreHelper.loadRootState()
      const result = await findAll({ headers, url })
      if (result.total === 1) {
        this.user = result.data[0]
        return result.data[0]
      }
      throw new Error('Failed to get user profile.')
    },
    async renewToken({ headers, url }: { headers?: any, url?: string }) {
      const { findAll } = StoreHelper.loadRootState()
      await findAll({ headers, url })
    }
  }
})
